<app-loading-spinner *ngIf="searching"></app-loading-spinner>

<h1 *ngIf="searchFailed">
  {{'SHOPRENTER_ERROR_SHOP_NOT_INSTALLED' | translate}}
</h1>

<h1 *ngIf="invalidArguments">
  {{'SHOPRENTER_ERROR_INVALID_ARGUMENTS' | translate}}
</h1>
